export default __webpack_public_path__ + "static/media/duurzame-ontwikkeling.9cfbb433.png";